import { render } from "./provider-editor.vue?vue&type=template&id=3006ee8a&ts=true"
import script from "./provider-editor.ts?vue&type=script&lang=ts"
export * from "./provider-editor.ts?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src62145823/src/codestar-connections.eu-west-1.amazonaws.com/git-http/021041300469/eu-west-1/c73932a4-e0ca-4ec0-8408-20b6c899ca8a/studyportals/ScholarshipsEditor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__